import React, { useEffect, useState } from 'react';

const LeadsDashboard: React.FC = () => {
  const [enquiries, setEnquiries] = useState<any[]>([]);
  const [registrations, setRegistrations] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<'enquiries' | 'registrations'>('enquiries');

  useEffect(() => {
    // API se data fetch kar rahe hain
    fetch('http://api.bestcoachinginjalandhar.com/api/get-enquiries')
      .then(res => res.json())
      .then(data => setEnquiries(data))
      .catch(err => console.error("Error fetching enquiries", err));

    fetch('http://api.bestcoachinginjalandhar.com/api/get-registrations')
      .then(res => res.json())
      .then(data => setRegistrations(data))
      .catch(err => console.error("Error fetching registrations", err));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto border bg-white shadow-lg rounded-xl overflow-hidden">
        
        {/* Header & Tabs */}
        <div className="bg-[#9e1c22] p-6 text-white flex justify-between items-center">
          <h1 className="text-2xl font-black uppercase tracking-widest">PW Leads Dashboard</h1>
          <div className="flex gap-2">
            <button 
              onClick={() => setActiveTab('enquiries')}
              className={`px-4 py-2 text-sm font-bold rounded ${activeTab === 'enquiries' ? 'bg-white text-[#9e1c22]' : 'bg-red-800 text-white hover:bg-red-700'}`}
            >
              Counselling Enquiries ({enquiries.length})
            </button>
            <button 
              onClick={() => setActiveTab('registrations')}
              className={`px-4 py-2 text-sm font-bold rounded ${activeTab === 'registrations' ? 'bg-white text-[#9e1c22]' : 'bg-red-800 text-white hover:bg-red-700'}`}
            >
              Registrations ({registrations.length})
            </button>
          </div>
        </div>

        {/* Data Table */}
        <div className="overflow-x-auto p-4">
          <table className="w-full text-left text-sm text-gray-600">
            <thead className="bg-gray-100 text-gray-800 uppercase text-xs font-bold">
              {activeTab === 'enquiries' ? (
                <tr>
                  <th className="p-3">ID</th>
                  <th className="p-3">Name</th>
                  <th className="p-3">Contact</th>
                  <th className="p-3">Course / Class</th>
                  <th className="p-3">School</th>
                  <th className="p-3">Date / Time</th>
                </tr>
              ) : (
                <tr>
                  <th className="p-3">ID</th>
                  <th className="p-3">Name</th>
                  <th className="p-3">Email</th>
                  <th className="p-3">Contact</th>
                  <th className="p-3">School</th>
                </tr>
              )}
            </thead>
            <tbody>
              {activeTab === 'enquiries' ? enquiries.map((item, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="p-3">{item.id}</td>
                  <td className="p-3 font-bold">{item.full_name}</td>
                  <td className="p-3">{item.contact_number} <br/><span className="text-xs text-green-600">WA: {item.whatsapp_number}</span></td>
                  <td className="p-3">{item.course} <br/> {item.class}</td>
                  <td className="p-3">{item.school_name}</td>
                  <td className="p-3">{item.enquiry_date} <br/> {item.time_slot}</td>
                </tr>
              )) : registrations.map((item, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="p-3">{item.id}</td>
                  <td className="p-3 font-bold">{item.student_name}</td>
                  <td className="p-3">{item.email}</td>
                  <td className="p-3">{item.contact_number}</td>
                  <td className="p-3">{item.school_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeadsDashboard;